// @Core
import { reloadedThemes, VARIANTS } from '@openbank/ziniaweb-ui-components';

const ENTRYPOINT_HEADER_COMPONENT_PROPS = {
  illustration: { illustration: 'logo_brand_adaptive-converted' },
  theme: reloadedThemes.cobranded_light_alternative,
  variant: VARIANTS.HeaderOnboardingVariantsType.DEFAULT,
};

const INTENTIONAL_NAVIGATION = 'intentional_navigation';

const INTENTIONAL_NAVIGATION_OFF = 'false';
const INTENTIONAL_NAVIGATION_ON = 'true';

export {
  ENTRYPOINT_HEADER_COMPONENT_PROPS,
  INTENTIONAL_NAVIGATION,
  INTENTIONAL_NAVIGATION_OFF,
  INTENTIONAL_NAVIGATION_ON,
};
